module.exports = __webpack_public_path__ + "img/apidays-ppt-4.1d836842.png";